module.exports = __webpack_public_path__ + "assets/img/yangli.19a743cb.jpg";